import React from "react";

const Filter = props => (
  <svg viewBox="0 0 21 21" fill="none" {...props}>
    <path
      d="M19.547 0H1.46C.6 0 .17 1.016.797 1.602l7.226 7.226v8.047c0 .313.117.625.39.781l3.126 2.188a.944.944 0 001.484-.782V8.829l7.188-7.226c.625-.586.195-1.602-.664-1.602z"
      fill="currentColor"
    />
  </svg>
);

export default Filter;
